import * as micLib from "microscope";
import { select, selectAll } from "d3-selection";

document.addEventListener("DOMContentLoaded", function(event) {
  // both
  const biobSelectorClass = "biobs-selector";
  const selectedBiobsClass = "selected-biobs";
  const preselectedBiobsFromServer = "preselected-biobs-from-server";
  const badgeSelectedBiobs = "badge-selected-biobs";

  const selectorParams = [
    {
      biob_list_id: "line-plot-pkgdb-sequence-selector",
      html_container_id: "line-plot-pkgdb-selector",
      html_hidden_input_name: "NameOrthoSid",
      selector: micLib.sequenceSelector,
      getSequenceById: micLib.getSequenceById,
      getOrganismById: micLib.getOrganismById,
      getStringifyName: micLib.getStringifySequenceById
    },
    {
      biob_list_id: "line-plot-refseq-sequence-selector",
      html_container_id: "line-plot-refseq-selector",
      html_hidden_input_name: "NameOrthoRefSeqSid",
      selector: micLib.refseqSequenceSelector,
      getSequenceById: micLib.getRefseqSequenceById,
      getOrganismById: micLib.getRefseqOrganismById,
      getStringifyName: micLib.getStringifyRefseqSequenceById
    }
  ];

  // Init and configure the selectors.
  selectorParams.map(function(params) {
    const d3ContainerSelector = select("#" + params.html_container_id);
    const cardBody = select("#" + params.html_container_id).node()
      .parentElement;
    const inputHtml = select(cardBody)
      .select("input.view-input")
      .node();
    const htmlSelectorContainer = d3ContainerSelector
      .select("." + biobSelectorClass)
      .node();
    const preselectedSid = d3ContainerSelector
      .selectAll("." + preselectedBiobsFromServer)
      .nodes()
      .reduce((accum, curr) => parseInt(curr.dataset.sid), null);
    // Callback function when selector updates.
    const selectorUpdateCb = function(sid, name) {
      selectionUpdateEventHandler(
        d3ContainerSelector,
        sid,
        params.html_hidden_input_name
      );
      d3ContainerSelector
        .select("." + biobSelectorClass)
        .select("." + "simple-biob-selector")
        .datum([{ name: name }])
        .call(inputAddon);
      //.call(selectedBiobsComponent);
    };

    // Create the selector
    const singleSequenceSelector = params.selector(false);
    singleSequenceSelector(
      params.biob_list_id,
      12,
      500,
      htmlSelectorContainer
    );
    // Attach event handler
    // is finished getting all the data
    singleSequenceSelector
      .isfinishFetching$(params.biob_list_id)
      .subscribe(function(data) {
        if (preselectedSid) {
          const sid = preselectedSid;
          const state = micLib.store.getState();
          updateBiobSelection(
            sid,
            params.getStringifyName(state, sid),
            params.html_hidden_input_name,
            d3ContainerSelector
          );
          inputHtml.disabled = false;
        } else {
          inputHtml.disabled = true;
        }
      });
    // Event handler selector selection update.
    // singleSequenceSelector
    //   .getBiobList$(params.biob_list_id)
    //   .subscribe(function(state) {
    //     const [seq, ...rest] = micLib.getInSelectionBiobs(
    //       state,
    //       params.biob_list_id
    //     );
    //     if (seq) {
    //       const { id: sid } = seq;
    //       updateBiobSelection(
    //         sid,
    //         params.getStringifyName(state, sid),
    //         params.html_hidden_input_name,
    //         d3ContainerSelector
    //       );
    //       inputHtml.disabled = false;
    //     }
    //   });
    singleSequenceSelector.onBiobListChange(function(state) {
      const [seq, ...rest] = micLib.getInSelectionBiobs(
        state,
        params.biob_list_id
      );
      if (seq) {
        const { id: sid } = seq;
        updateBiobSelection(
          sid,
          params.getStringifyName(state, sid),
          params.html_hidden_input_name,
          d3ContainerSelector
        );
        inputHtml.disabled = false;
      }
    });
  });

  function updateBiobSelection(
    sid,
    name,
    htmlHiddenInputName,
    d3ContainerSelector
  ) {
    selectionUpdateEventHandler(d3ContainerSelector, sid, htmlHiddenInputName);
    d3ContainerSelector
      // .select("." + badgeSelectedBiobs)
      .select("." + biobSelectorClass)
      .select("." + "simple-biob-selector")
      .datum([{ name: name }])
      .call(inputAddon);
  }
  function selectionUpdateEventHandler(rootSelector, seqId, inputName) {
    const state = micLib.store.getState();
    rootSelector
      .select("." + selectedBiobsClass)
      .datum([
        {
          id: seqId
        }
      ])
      .call(hiddenSelectedBiobsInput, inputName);
  }
}); // END DOMContentLoaded eventHandler
function hiddenSelectedBiobsInput(selection, name) {
  selection.each(function(_data) {
    const root = select(this);
    const inputs = root.selectAll("input").data(_data);
    //exit
    inputs.exit().remove();
    //enter
    const inputs_e = inputs
      .enter()
      .append("input")
      .attr("type", "hidden")
      .attr("name", name);
    //update
    const inputs_u = inputs_e.merge(inputs).attr("value", d => d.id);
  });
}

function selectedBiobsComponent(selection) {
  selection.each(function(_data) {
    const root = select(this);
    const spans = root.selectAll("div").data(_data);
    //exit
    spans.exit().remove();
    //enter
    const spans_e = spans
      .enter()
      .append("div")
      .classed("badge badge-primary", true);
    //update
    const spans_u = spans_e.merge(spans).text(d => d.name);
  });
}

function inputAddon(selection) {
  selection.each(function(_data) {
    const root = select(this);
    root.select("input.single-search").style("border-radius", "0rem");
    const spans = root.selectAll("div.input-group-append").selectAll("span.selected-genome").data(_data);
    //exit
    spans.exit().remove();
    //enter
    const spans_e = spans
      .enter()
      .append("span")
      .style("border-radius", "0rem .25rem .25rem 0rem")
      .style("font-size", "0.8rem")
      .classed("input-group-text selected-genome font-weight-bold", true);
    //update
    const spans_u = spans_e.merge(spans).text(d => d.name);
  });
}
